import axios from 'axios'
import { getInstance } from '@/auth'
import { API_CONFIG } from '@/config'

const callInfo = (name, options) => {
  const infos = {
    getTranslations: () => ({
      method: 'get',
      url: `/translations/${options.clientId}`
    }),
    getUser: () => ({
      method: 'get',
      url: '/user'
    }),
    getFilters: () => ({
      method: 'get',
      url: `/filters/${options.clientId}`
    }),
    getResults: () => ({
      method: 'get',
      url: `/results/${options.clientId}`
    }),
    getReport: () => ({
      method: 'get',
      url: `/report/${options.clientId}/${options.reportId}`
    }),
    getFiles: () => ({
      method: 'post',
      url: '/files'
    }),
    postSync: () => ({
      method: 'post',
      url: '/sync'
    })
    /*
    postFiles: () => ({
      method: 'post',
      url: '/upload'
    })
    */
  }
  return infos[name](options)
}

export default {
  async call (name, options, success, error) {
    const { url, method } = callInfo(name, options)
    const { params = {}, data = {} } = options || {}
    const auth = getInstance()
    const token = await auth.getAuthToken()

    return axios({
      baseURL: API_CONFIG.baseUrl,
      url,
      headers: {
        'Content-Type': (method === 'post') ? 'multipart/form-data' : 'text/html',
        'Authorization': `Bearer ${token}`
      },
      maxContentLength: null,
      method,
      params,
      data
    })
      .then(res => success(res.data))
      .catch(err => error(err))
  },
  async getFile (url, options, success, error) {
    const { params = {} } = options || {}
    const auth = getInstance()
    const token = await auth.getAuthToken()

    return axios({
      url,
      headers: {
        'Content-Type': 'text/html',
        'Authorization': `Bearer ${token}`
      },
      timeout: 30000,
      method: 'get',
      params,
      responseType: 'blob'
    })
      .then(res => success(res.data))
      .catch(err => error(err))
  }
}
